import { userHasRole } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    return userHasRole(user, ["sysadmin"]);
  },
};